import { UserSummaryProductModel } from './user-summary-product.model';
import { UserSummaryModel } from './user-summary.model';

export class UserSummaryProdInfoModel {
    userInfo: UserSummaryModel;
    userSummaryProductModelArr: Array<UserSummaryProductModel>;
}
